import { Instagram, Heart } from "lucide-react";
import { openCookiePreferences } from "@/lib/consent";
import { Link } from "react-router-dom";

const LOGO_WHITE = "/maternnia-logo-white.png";

const FOOTER_COLUMNS = [
  {
    title: "Plataforma",
    links: [
      { label: "Início", to: "/" },
      { label: "Etapas", href: "/#etapas" },
      { label: "Profissionais", to: "/profissionais" },
      { label: "Conteúdos", to: "/conteudos" },
      { label: "Sobre", href: "/#sobre" },
    ],
  },
  {
    title: "Etapas",
    links: [
      { label: "Planejamento", to: "/planejamento" },
      { label: "Gestação", to: "/gestacao" },
      { label: "Parto", to: "/parto" },
      { label: "Pós-parto", to: "/pos-parto" },
    ],
  },
  {
    title: "Para fornecedores",
    links: [
      { label: "Seja parceiro", to: "/fornecedores" },
      { label: "Como funciona", href: "/#fornecedores" },
      { label: "Cadastre seu serviço", to: "/fornecedores" },
    ],
  },
];

const POLITICAS_LINKS = [
  { label: "Privacidade", to: "/privacidade" },
  { label: "Termos de uso", to: "/termos" },
  { label: "Política editorial", to: "/politica-editorial" },
];

const linkClass = "text-sm text-white/65 hover:text-maternnia-pink transition-colors font-light";

const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-maternnia-charcoal text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-4">
            <img src={LOGO_WHITE} alt="Maternnia" className="h-12 w-auto object-contain mb-6" />
            <p className="text-sm leading-relaxed text-white/70 max-w-xs font-light">
              Clareza, confiança e apoio em cada fase da jornada — do planejamento ao pós-parto.
            </p>
            <div className="flex items-center gap-4 mt-7">
              {[
                { Icon: Instagram, label: "Instagram", href: "https://www.instagram.com/maternnia.br" },
              ].map(({ Icon, label, href }, i) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`footer-social-${i}`}
                  className="h-10 w-10 flex items-center justify-center rounded-full border border-white/15 hover:bg-maternnia-pink hover:border-maternnia-pink transition-all duration-200"
                  aria-label={label}
                >
                  <Icon size={18} />
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-8 grid grid-cols-2 md:grid-cols-3 gap-8">
            {FOOTER_COLUMNS.map((col) => (
              <div key={col.title}>
                <h4 className="text-sm font-semibold tracking-wide text-white mb-5">{col.title}</h4>
                <ul className="space-y-3">
                  {col.links.map((link) => (
                    <li key={link.label}>
                      {link.to ? (
                        <Link to={link.to} className={linkClass}>{link.label}</Link>
                      ) : (
                        <a href={link.href} className={linkClass}>{link.label}</a>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-5">
          <p className="text-xs text-white/50 order-2 md:order-1">© {new Date().getFullYear()} Maternnia. Todos os direitos reservados.</p>
          <nav className="order-1 md:order-2 flex flex-wrap items-center justify-center gap-x-6 gap-y-2" aria-label="Políticas">
            {POLITICAS_LINKS.map((p) => (
              <Link key={p.to} to={p.to} data-testid={`footer-politica-${p.to.replace("/", "")}`} className="text-xs text-white/60 hover:text-maternnia-pink transition-colors">
                {p.label}
              </Link>
            ))}
            <button data-testid="footer-cookie-prefs" onClick={openCookiePreferences} className="text-xs text-white/60 hover:text-maternnia-pink transition-colors">
              Preferências de cookies
            </button>
          </nav>
        </div>
        <p className="mt-6 text-xs text-white/40 text-center md:text-right flex items-center justify-center md:justify-end gap-1.5">
          Feito com <Heart size={12} className="text-maternnia-pink fill-maternnia-pink" /> para mulheres e famílias
        </p>
      </div>
    </footer>
  );
};

export default Footer;
